/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2025 Deere & Company

import React, { useState } from 'react';
import NumberOfRecordsFound from '../../../../sharedmodules/components/number-of-records-found';
import PinPlates from '../state/duplicate-pin-plate-search';
import PropTypes from 'prop-types';
import ReportGrid from '../../../../sharedmodules/components/report-grid';
import ReportHeader from '../../../../sharedmodules/components/report-header/report-header';
import { getAgGridLocaleText } from '../../../../sharedmodules/utils/ag-grid-locale-text';
import { getDuplicatePinPlateColumnDefinitions } from '../utils/duplicate-pin-plate-columns';
import { gridOptions } from '../../../../sharedmodules/constants/grid-options';

const PinPlateReport = (props) => {

    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridApi, setGridApi] = useState(null);

    const onGridReady = (params) => {

        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

    };

    return (
        <div className="product-list">
            <div className="list-header">
                {props.children}
            </div>
            <div>
                <NumberOfRecordsFound count={props.pinPlates.length} />
                <section className="report">
                    <ReportHeader
                        columnApi={gridColumnApi}
                        gridApi={gridApi}
                        reportName="duplicate-pin-plate"
                        showReportLayout={false}
                    />
                    <ReportGrid
                        columnDefs={getDuplicatePinPlateColumnDefinitions()}
                        enableFilter
                        gridOptions={gridOptions}
                        headerHeight="32"
                        localeText={getAgGridLocaleText()}
                        onColumnVisible={props.onColumnRemoved}
                        onGridReady={onGridReady}
                        rowData={props.pinPlates}
                        rowHeight="32"
                    />
                </section>
            </div>
        </div>
    );

};

PinPlateReport.displayName = 'PinPlateReport';
PinPlateReport.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    children: PropTypes.node,
    columnApi: PropTypes.object,
    gridApi: PropTypes.object,
    handleGridApiDefinition: PropTypes.func,
    onColumnRemoved: PropTypes.func,
    pinPlates: PropTypes.arrayOf(PropTypes.instanceOf(PinPlates)).isRequired,
    showNoResultsFound: PropTypes.bool,
    updateCommentAction: PropTypes.func,
    updateStatusAction: PropTypes.func,
};

export default PinPlateReport;
